import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia.claim.additionalinformation.documentupload.Unable to Download',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    otherDocument: {
        id: 'twia.claim.additionalinformation.documentupload.Other document',
        defaultMessage: 'Other document',
    },
    badFileTypeTitle: {
        id: 'twia.claim.additionalinformation.documentupload.Bad File Type Title',
        defaultMessage: 'Bad File Format',
    },
    badFileTypeBody: {
        id: 'twia.claim.additionalinformation.documentupload.Bad File Type Body',
        defaultMessage: 'Please upload a supported file format: .avi, .bmp, .doc, .docm, .docx, .dot, .gif, .jpeg, .jpg, .mov, .mpg, .pdf, .png, .ppt, .pptx, .rtf, .tif, .tiff, .txt, .wav, .wmv, .xls, .xlsx.',
    },
    downloadError: {
        id: 'claim.common.views.Unable to download file',
        defaultMessage: 'Unable to download file, please check back later',
    },
    description: {
        id: 'twia-tfpa.claimDetails.summary.documents.Document description',
        defaultMessage: 'DESCRIPTION',
    },
});
